import VerifiedIcon from "@mui/icons-material/Verified";
import { Box, Stack } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";


type PlanPerksCardProps = {
  title: string;
  monthlyCost: number;
  perks: string[];
};

export function PlanPerksCard({ title, monthlyCost, perks }: PlanPerksCardProps) {
  return (
    <Box className="max-w-[353px] w-full">
      <Typography variant="subtitle" className="bg-primary-darker text-white px-7 py-2">
        {title}
      </Typography>

      <Stack className="border-solid border-primary-darker border px-7 py-3" spacing={1}>
        <Typography variant="detail" className="text-primary-dark">
          <span className="text-primary-dark text-[27.32px]">${monthlyCost}</span> /Per month
        </Typography>

        <Typography variant="detail" fontWeight="bold" className="text-primary-dark">
          Includes:
        </Typography>

        <Stack spacing={1}>
          {perks.map((perk) => (
            <Stack direction="row" spacing={1} alignItems="center">
              <VerifiedIcon className="text-primary-darker" />
              <Typography variant="small" className="text-primary-dark">
                {perk}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}
